<template>
    <v-row>
        <v-col :cols="filterColumnCount" v-if="filtersVisible">
            <base-card>
                <!-- <v-card-title>
                    <span class="font-weight-bold">Filters</span>
                </v-card-title> -->
                <!-- <v-card-text class="-pt-0">
                    <advanced-grid-filters-list :dynamic="false" :fields="filterfields" v-model:filtervalue="filtercriteria" @search="onSearch" />
                </v-card-text>                           -->
            </base-card>            
        </v-col>
        <v-col :cols="gridColumnCount">
            <base-card>
                <v-card-title>                                                        
                    <div class="d-flex justify-space-between flex">
                        <h5 class="ma-5 mb-0 d-flex flex" style="min-width: 130px;">{{ entitynameplural }}</h5>                        
                        <v-autocomplete
                            class="ma-4 mb-0 d-flex flex"
                            v-model="selectedNetworks"
                            :items="networkOptions"
                            label="Networks"
                            multiple
                            chips
                            small-chips
                            clearable
                            hide-details
                            dense
                            item-text="text"
                            item-value="value"
                            ></v-autocomplete>
                        <v-text-field
                                style="max-width: 300px;"
                                v-model="quicksearch"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details     
                                class="col-5"   
                                @input="triggerQuicksearch"
                            ></v-text-field>
                        <v-btn class="ma-2" dark color="danger" :to="createuri">
                            <v-icon>mdi-plus</v-icon>
                            Add {{ entityname }}
                        </v-btn>                        
                    </div>
                </v-card-title>
                <v-tabs
                    v-model="activeTab"
                    background-color="transparent"
                    color="primary"
                    class="px-4"
                >
                    <v-tab>
                        <v-icon left small>mdi-map-marker</v-icon>
                        Map
                    </v-tab>
                    <v-tab>
                        <v-icon left small>mdi-format-list-bulleted</v-icon>
                        List
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item>
                        <div class="location-grid__map-wrapper pa-4">
                            <omnimapx
                                v-if="mapPois.length"
                                :pois="mapPois"
                                @focusAppointment="handleLocationMarkerClick"
                            />
                            <v-alert
                                v-else
                                type="info"
                                border="left"
                                outlined
                                class="ma-0"
                            >
                                No map data available for the current result set.
                            </v-alert>
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <v-data-table
                            v-model="selected"                    
                            :headers="headers"
                            :options.sync="pagingOptions"
                            :server-items-length="totalItemCount"
                            :items="gridData"
                            item-key="name"
                            :show-select="false"
                            class="elevation-1 table-one"
                            multi-sort
                            :footer-props="{
                                'items-per-page-options': [5, 10, 20, 50]
                            }"
                        >
                            <template v-slot:item.title="{item}">
                                <div class="d-flex align-center">

                                    <p class="ma-0 font-weight-medium">
                                        {{ item.title }}
                                    </p>
                                </div>
                            </template>
                            <template v-slot:item.network_id="{item}">
                                <div class="d-flex align-center">                            
                                    <p class="ma-0 font-weight-medium">
                                        {{ extractOptionDescription(item.network_id, networkOptions) }}
                                    </p>
                                </div>
                            </template>
                            <template v-slot:item.aud_create_date="{item}">
                                <div class="d-flex align-center">                        
                                    <p class="ma-0 font-weight-medium">
                                        {{ item.aud_create_date | formatDate }}
                                    </p>
                                </div>
                            </template>
                            

                            <template v-slot:item.action="{item}">
                                <div class="d-flex">
                                    <v-tooltip top>
                                        <template v-slot:activator="{on, attrs}">
                                            <v-btn                                        
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                :to="edituri + item.code"
                                            >
                                                <v-icon>mdi-pencil-box-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{on, attrs}">
                                            <v-btn                                        
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="deleteShowConfirmDialog(item)"
                                            >
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete</span>
                                    </v-tooltip>

                                    

                                </div>
                            </template>                    
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
                <v-dialog v-model="deleteDialog" width="500">
                    <v-card class="">
                        <v-card-title>
                            <span class="headline">Delete</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                Are you sure you want to delete this record?
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary darken-1"
                                text
                                @click="deleteDialog = false"
                                >Cancel</v-btn
                            >
                            <v-btn
                                color="primary darken-1"
                                text
                                @click="deleteItem()"
                                >Delete</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </base-card>
            <v-dialog v-model="locationDetailsDialog" max-width="480">
                <v-card v-if="selectedMapLocation">
                    <v-card-title class="headline">
                        {{ selectedMapLocation.title }}
                    </v-card-title>
                    <v-card-text>
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>Code</v-list-item-subtitle>
                                    <v-list-item-title>{{ selectedMapLocation.code }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>Network</v-list-item-subtitle>
                                    <v-list-item-title>
                                        {{ extractOptionDescription(selectedMapLocation.network_id, networkOptions) }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="locationDetailsDialog = false">Close</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            :to="selectedMapLocation ? getAdpointsRoute(selectedMapLocation) : undefined"
                            @click="locationDetailsDialog = false"
                        >
                            View Adpoints
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </v-row>
</template>

<script>
import {api} from "src/api/index";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList"
import OmniMapx from "@/components/core/omnimapx";
import { formatDateLabel } from "@/core/date-utils.js";

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Locations List'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList,
        omnimapx: OmniMapx
    },
    data() {
        return {
            entityname: 'Location',
            entitynameplural: 'Locations',
            edituri: '/mng/adpoints/location/edit/',
            createuri: '/mng/adpoints/location/create',
            // gridConfig: {
            //     rowActions: [
            //         {
            //             title: "Edit",
            //             action: "localMethodNameGoesHere",
            //             icon: "iconGoesHere",
            //         },
            //         {
            //             title: "Delete",
            //             action: "localMethodNameGoesHere",
            //             icon: "iconGoesHere",
            //         },
            //     ],
            //     columns: [
            //         {title: "Name", 
            //         type: "text", 
            //         bindings: {
            //             datafield: "fullname",
            //             prependIcon: "",
            //             appendIcon: "",
            //             formatter: (rowData) => {
            //                 return v;
            //             },
            //             statusMapper: (rowData) => {
            //                 return {
            //                     color: "",
            //                     icon: "",
            //                     text: ""
            //                 }
            //             },

            //         }}
            //     ]
            // },
            totalItemCount: 0,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            deleteDialog: null,
            itemToDelete: null,
            quicksearch: '',
            pagingOptions: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: []
            },
            selected: [],
            baseData: [],
            select_field: null,
            select_operator: null,
            filtercriteria: null,
            filterfields: [],                    
            filtersVisible: false,
            headers: [                
                {text: 'Title', align: 'start', value: 'title'},
                {text: 'Code', align: 'start', value: 'code'},
                {text: 'Network', align: 'start', value: 'network_id'},                
                //extra_info fields start
                //{text: 'xxfieldxx', align: 'start', value: 'extra_info.xxfieldxx'},                
                //extra_info fields end
                {text: 'Create Date', value: 'aud_create_date'},                
                {text: 'Action', value: 'action'}
            ],
            networkOptions: [],
            activeTab: 0,
            locationDetailsDialog: false,
            selectedMapLocation: null,
            selectedNetworks: [],
            mapLocations: [],
            mapFetchLimit: 500,
            mapDataStale: true
        }
    },
    filters: {
        formatDate(value) {
            return formatDateLabel(value);
        }
    },
    watch: {
      pagingOptions: {
        handler () {
          this.fetchGridData();
        },
        deep: true,
      },
            selectedNetworks: {
                handler() {
                        this.onNetworkFilterChange();
                },
                deep: true
            },
            activeTab(newTab) {
                if(newTab === 0 && (this.mapDataStale || this.mapLocations.length === 0)) {
                        this.fetchMapData();
                }
            }
    //   quicksearch: function() {
    //       this.fetchGridData();
    //   }
    },
    computed: {
        gridData() {
            //const rspData = this.baseData;
            //return this.formatListData(rspData);
            return this.baseData;
        },
        filterColumnCount() {
            const d = this.filtersVisible;
            return (d ? 2 : 0);
        },
        gridColumnCount() {
            const d = this.filtersVisible;
            return (d ? 10 : 12);
        },
        mapPois() {
            const sourceData = (this.activeTab === 0 ? this.mapLocations : this.gridData) || [];
            let rspoi = sourceData
                .filter(loc => this.hasValidCoords(loc))
                .map((loc, index) => {
                    const lat = parseFloat(loc.latitude);
                    const lng = parseFloat(loc.longitude);
                    return {
                        randcode: loc.code || `location_${index}`,
                        id: loc.code || index,
                        orderno: index + 1,
                        label: loc.code,
                        route: true,
                        info: {
                            coords: { lat, lng },
                            marker: 'route'
                        },
                        payload: loc
                    };
                });
            return rspoi;
        }
    },
    methods: {
        formatListData(rspData) {
            const d = rspData.map(d => { 
                return {
                    ...d, 
                    fullname: d.firstName + ' ' + d.lastName,
                    status: ( (d.disabled) ? "Disabled" :
                        (d.invitation_code) ? "Invited" :
                        (d.activation_date === "" || d.activation_date == null) ? "Awaiting Activation" : "Active"                         
                    )
                } })
            return d;
        },
        buildQueryString(pagingOverride=null) {
            let qstr = "";
            const paging = pagingOverride || this.pagingOptions;
            const sortBy = paging.sortBy || [];
            const sortDesc = paging.sortDesc || [];
            const page = paging.page || paging.currentPage || 1;
            const limit = paging.itemsPerPage || paging.limit || 10;
            qstr += "?currentPage=" + page + "&limit=" + limit;
            for(let i=0; i<sortBy.length; i++) {
                qstr += "&sortBy[" + i + "]=" + sortBy[i];
            }
            for(let i=0; i<sortDesc.length; i++) {
                qstr += "&sortDesc[" + i + "]=" + sortDesc[i];
            }
            if(this.filtercriteria && this.filtercriteria.qs) {
                qstr += this.filtercriteria.qs;
            }
            if(this.quicksearch && this.quicksearch.length > 2){
                qstr += "&quicksearch=" + encodeURIComponent(this.quicksearch);
            }
            if(this.selectedNetworks && this.selectedNetworks.length > 0) {
                qstr += "&networkIds=" + this.selectedNetworks.join(',');
            }
            return qstr;
        },
        async fetchGridData() {            
            const qstr = this.buildQueryString();
            const rsp = await api.location.getList(qstr);
            this.baseData = rsp.data.data; //.map(d => { return {...d, fullname: d.firstName + ' ' + d.lastName} }); 
            this.totalItemCount = rsp.data.total;
            this.mapDataStale = true;
            if(this.activeTab === 0) {
                await this.fetchMapData();
            }
        },
        toggleFilterView() {
            this.filtersVisible = ! this.filtersVisible
        },
        onSearch() {
            //alert(JSON.stringify(this.filtercriteria, null, 2));
            //alert(JSON.stringify(this.filtercriteria.qs, null, 2));
            this.fetchGridData();
        },
        triggerQuicksearch() {
            // if (this.quicksearch && this.quicksearch.length > 2) {
            //     this.fetchGridData();
            // }             
            this.fetchGridData();
        },
        async fetchMapData() {
            let combinedResults = [];
            let currentPage = 1;
            let fetchedCount = 0;
            let totalItems = 0;
            const pageSize = this.mapFetchLimit;
            do {
                const qstr = this.buildQueryString({
                    sortBy: [],
                    sortDesc: [],
                    page: currentPage,
                    itemsPerPage: pageSize
                });
                const rsp = await api.location.getList(qstr);
                const chunk = (rsp.data && rsp.data.data) ? rsp.data.data : [];
                totalItems = rsp.data?.total || chunk.length;
                combinedResults = combinedResults.concat(chunk);
                fetchedCount += chunk.length;
                currentPage += 1;
                if(chunk.length === 0) {
                    break;
                }
            } while(fetchedCount < totalItems);
            this.mapLocations = combinedResults;
            this.mapDataStale = false;
        },
        deleteItem() {            
            this.deleteDialog = false;
            this.error = '';                                                           
            this.loading = true;          
            api.location.delete(this.itemToDelete.code)
            .then((rsp)=>{                              
                this.snackbarColor = "green";
                this.snackbarMessage = "Record deleted.";
                this.snackbar = true;  
                this.fetchGridData();                
            })
            .catch((error)=>{
                //this.error = error.response.data.message;
                this.snackbarColor = "red";
                this.snackbarMessage = error.response.data.message;
                this.snackbar = true;
            })
            .finally(()=>{
                this.loading = false;
            })  
        },
        deleteShowConfirmDialog(item) {
            this.itemToDelete = item;
            this.deleteDialog = true;            
        },

        extractOptionDescription(idValue, optionsList) {            
            let et = optionsList.find(o=>o.value == idValue);
            if(et) {
                return et.text;
            }         
            return '-';            
        },
        hasValidCoords(location) {
            if(!location) {
                return false;
            }
            const lat = parseFloat(location.latitude);
            const lng = parseFloat(location.longitude);
            return !isNaN(lat) && !isNaN(lng);
        },
        handleLocationMarkerClick(poi) {
            const picked = poi?.payload || poi;
            if(!picked) {
                return;
            }
            this.selectedMapLocation = picked;
            this.locationDetailsDialog = true;
        },
        getAdpointsRoute(location) {
            if(!location) {
                return {};
            }
            return {
                name: 'adpoints-dashboard',
                query: {
                    location: location.code
                }
            };
        },
        onNetworkFilterChange() {
            if(this.pagingOptions.page !== 1) {
                this.pagingOptions.page = 1;
            } else {
                this.fetchGridData();
            }
        }
    },
    async created() {
        const rsp = await api.adpoint.getInitData();
        this.networkOptions.push(...rsp.data.networkOptions);

        await this.fetchGridData();
        // const rsp = await api.users.getList("");
        // this.baseData = rsp.data.data.map(d => { return {...d, fullname: d.firstName + ' ' + d.lastName} }); 
        // this.baseData = [{
        //             img: require('@/assets/images/avatars/001-man.svg'),
        //             name: 'Jhon Doe',
        //             calories: 'Walmart',
        //             fat: '95',
        //             carbs: '$14,384',
        //             protein: '03/24/2020',
        //             badge: 'Active'
        //         },
        //         {
        //             img: require('@/assets/images/avatars/002-woman.svg'),
        //             name: 'Elizabeth Doe',
        //             calories: 'KFC',
        //             fat: '876',
        //             carbs: '$38,384',
        //             protein: '03/24/2020',
        //             badge: 'Deactive'
        //         },]
        //console.log("DBGINDICATOR_ " + JSON.stringify(XYZ, null, ''));
    },  
    async mounted() {        
        // let ff = this.filterfields.find(i=>i.selectvalue === "xxenttxx");        
        // if(ff) {
        //     const rsp = await api.xxenttxx.getAll();            
        //     ff.listItems = rsp.data.map(i=> {return {selectvalue: i.code, selecttext: i.title}});
        // }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .table-one {
    thead.v-data-table-header- {
        tr {
            &:hover {
                background-color: #f2f3f8;
            }
            th {
                span {
                    font-size: 16px;
                    color: #304156;
                }
            }
        }
        tr {
            td {
                padding-bottom: 20px;
                padding-top: 20px;
            }
        }
    }
    tbody {
        tr {
            &:hover {
                // background-color: #f2f3f8 !important;
            }
        }
    }
}
.location-grid__map-wrapper {
    height: 540px;
    background-color: transparent;
}
</style>
